import { render, staticRenderFns } from "./chatBook.vue?vue&type=template&id=b6684ef2&scoped=true&"
import script from "./chatBook.vue?vue&type=script&lang=ts&"
export * from "./chatBook.vue?vue&type=script&lang=ts&"
import style0 from "./chatBook.vue?vue&type=style&index=0&id=b6684ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6684ef2",
  null
  
)

export default component.exports